<div class="index-selector">
  <button
    class="tw-rounded-full md:tw-w-fit tw-w-14 tw-h-14 tw-bg-white tw-text-main tw-shadow-1 tw-flex tw-justify-center md:tw-px-7 md:tw-py-2 focus:tw-outline-0 hover:tw-bg-gray-50 disabled:tw-opacity-60 disabled:tw-cursor-not-allowed"
    (click)="toggleOpen()" type="button" cdkOverlayOrigin #trigger="cdkOverlayOrigin"
    [class.!tw-bg-main]="isOpen"
    [class.!tw-text-white]="isOpen"
    id="indexSelectorTrigger"
  >
    <i class="fas fa-chart-line tw-self-center tw-text-lg md:tw-text-base"></i>
    <span class="tw-hidden tw-ml-2 md:tw-inline-block tw-text-base tw-font-medium tw-self-center tw-text-main-text" [class.!tw-text-white]="isOpen">
      {{ selectedOptionLabel | translate }}
    </span>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
  >
    <article class="tw-rounded-lg tw-shadow-xl tw-p-3 tw-bg-white tw-mt-1 tw-max-h-[300px] tw-overflow-y-auto tw-w-[300px]" id="indexSelectorMenu">
      <mat-radio-group class="tw-flex tw-flex-col tw-w-full" [(ngModel)]="selectedOption" (change)="selectOption($event.value)">
        <mat-radio-button class="tw-my-1" *ngFor="let option of options" [value]="option.id">
          {{ option.label | translate }} <span *ngIf="option.hasNewTag" class="tw-bg-green-600 tw-rounded-full tw-px-1 tw-text-xs tw-text-white">{{ 'commons.new' | translate }}</span>
        </mat-radio-button>
      </mat-radio-group>
    </article>
  </ng-template>
</div>
